export const getEditUsageCount = () => {
  const value = localStorage.getItem('lf_hasEdited');
  return !isNaN(parseInt(value, 10)) ? parseInt(value, 10) : 0;
};

export const updateEditUsageCount = () => {
  localStorage.setItem('lf_hasEdited', getEditUsageCount() + 1);
};
